import React, { useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import './PaymentSuccess.css';

const PaymentSuccess = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { patientUser } = useContext(AuthContext);
  const { appointmentId, transactionId, amount, appointmentData, doctorName } = state || {};

  useEffect(() => {
    if (!patientUser || !patientUser.id) {
      console.error('PaymentSuccess: User not logged in', { patientUser });
      navigate('/login?type=patient');
      return;
    }

    if (!appointmentId || !transactionId) {
      console.error('PaymentSuccess: Missing payment data', { appointmentId, transactionId });
      navigate('/patient-dashboard/' + patientUser.id); // Fallback to dashboard
      return;
    }

    console.log('PaymentSuccess: Redirecting to dashboard in 5 seconds', { patientUserId: patientUser.id });
    const timer = setTimeout(() => {
      navigate(`/patient-dashboard/${patientUser.id}`);
    }, 5000);
    return () => clearTimeout(timer);
  }, [navigate, patientUser, appointmentId, transactionId]);

  if (!patientUser || !patientUser.id) {
    return (
      <div className="payment-success">
        <h2>Error</h2>
        <p>User not logged in. Please log in again.</p>
        <button onClick={() => navigate('/login?type=patient')}>Go to Login</button>
      </div>
    );
  }

  if (!appointmentId || !transactionId) {
    return (
      <div className="payment-success">
        <h2>Payment Success</h2>
        <p>Payment was successful, but some details are missing. Check your dashboard for the appointment.</p>
        <button onClick={() => navigate(`/patient-dashboard/${patientUser.id}`)}>Go to Dashboard</button>
      </div>
    );
  }

  return (
    <div className="payment-success">
      <h2>Payment Successful!</h2>
      <div className="success-details">
        <p><strong>Transaction ID:</strong> {transactionId}</p>
        <p><strong>Paid Amount:</strong> ₹{amount.toFixed(2)}</p>
        <p><strong>Appointment ID:</strong> {appointmentId}</p>
        <h3>Appointment Details</h3>
        <p><strong>Patient Name:</strong> {appointmentData.name}</p>
        <p><strong>Doctor Name:</strong> {doctorName}</p>
        <p><strong>Date:</strong> {new Date(appointmentData.date).toLocaleString()}</p>
        <p><strong>Symptoms:</strong> {appointmentData.symptoms || 'N/A'}</p>
      </div>
      <p>You will be redirected to your dashboard in 5 seconds...</p>
      <button onClick={() => navigate(`/patient-dashboard/${patientUser.id}`)}>
        Go to Dashboard Now
      </button>
    </div>
  );
};

export default PaymentSuccess;